<template>
  <v-app>
    <Toolbar />
    <v-content>
      <Title />
      <Abstract />
      <v-spacer></v-spacer>
      <Calculator />
      <Disclaimer />
      <Footer/>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar';
import Title from './components/Title';
import Abstract from './components/Abstract';
import Calculator from './components/Calculator';
import Disclaimer from './components/Disclaimer';
import Footer from './components/Footer';

export default {
    name: 'App',
    components: {
        Toolbar,
        Title,
        Abstract,
        Calculator,
        Disclaimer,
        Footer
    },
};
</script>
